import React from "react";
import { Box, Stack, Text } from "@chakra-ui/react";
import { useTextVariants } from "@/theme/components/useSectionHeading";
import { TableFooter } from "./constants";

const PricingFooter = () => {
  const TextVariant = useTextVariants();
  return (
    <Stack spacing={4} mt={1}>
      <Box textAlign={"center"}>
        <Text as="span" variant={TextVariant} color="text.100" fontWeight={600}>
          NOTE :
        </Text>
        <Text as="span" variant={TextVariant} color="text.100" textAlign={"center"}>
          {TableFooter.note}
        </Text>
      </Box>
      <Text variant={TextVariant} color="text.100" fontStyle={"italic"}>
        {TableFooter.text}
      </Text>
    </Stack>
  );
};

export default PricingFooter;
